import { ref } from "vue";
import { useStorage } from "@vueuse/core";
import { useSessionStorage } from "@vueuse/core";

export const tabIDs = useStorage<Array<number>>("tbis", []);
export const currentID = useSessionStorage<number>("tbi", Math.floor(Math.random() * 100));
export const duplicatedSession = ref(false);

export const currentStationIDSession = useStorage<number>("crtstn_id", 0);
export const currentStationUUIDSession = useStorage<number>("crtstn_uuid", 0);

export const currentStationIDSessionExists =
	currentStationIDSession.value && (currentStationIDSession.value !== Number(-1) ||
	currentStationIDSession.value !== 0)
		? true
		: false;
